import * as types from "./actionTypes";
import * as postCommentsApi from "../../api/postCommentApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";
import moment from "moment"

export function userPostsLoaded(posts) {
    return { type: types.LOAD_USER_POSTS, posts }
}

export function groupPostsLoaded(posts) {
    return { type: types.LOAD_GROUP_POSTS, posts }
}

export function eventPostsLoaded(posts) {
    return { type: types.LOAD_EVENT_POSTS, posts }
}

export function newFeedLoaded(posts) {
    return { type: types.LOAD_NEWS_POSTS, posts }
}

export function postCommentsLoaded(comments) {
    return { type: types.LOAD_POST_COMMENTS, comments }
}

export function postLoaded(post) {
    return { type: types.LOAD_POST, post }
}

export function postAdded(post) {
    return { type: types.ADD_POST, post }
}

export function postEdited(post) {
    return { type: types.EDIT_POST, post }
}

export function postDeleted(post) {
    return { type: types.DELETE_POST, post}
}

export function commentAdded(comment) {
    return { type: types.ADD_COMMENT, comment}
}

export function commentEdited(comment) {
    return { type: types.EDIT_COMMENT, comment }
}

export function commentDeleted(comment) {
    return { type: types.DELETE_COMMENT, comment }
}

export function postImageDeleted(postId, fileName) {
    return { type: types.DELETE_POST_IMAGE, postId, fileName }
}

export function commentImageDeleted(commentId, fileName) {
    return { type: types.DELETE_COMMENT_IMAGE, commentId, fileName }
}

export function reactedToPost(reaction) {
    return { type: types.REACT_POST, reaction };
}

export function unReactedToPost(reaction) {
    return { type: types.UNREACT_POST, reaction };
}

export function changeReactionToPost(reaction) {
    return { type: types.CHANGE_REACTION_POST, reaction };
}

//Time Offset for browser localisation; 
const offSet = new Date().getTimezoneOffset();

export function loadUserPosts(criteria) {
    return dispatch => {
        return postCommentsApi.getUserPosts(criteria)
            .then(posts => {
                posts.results.map(post => {
                    post.postedOn = moment(post.postedOn).subtract(offSet, 'm');
                })
                dispatch(userPostsLoaded(posts));
                return posts;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadNewsFeed(criteria) {
    return dispatch => {
        return postCommentsApi.getNewsFeed(criteria)
            .then(posts => {
                posts.results.map(post => {
                    post.postedOn = moment(post.postedOn).subtract(offSet, 'm');
                })
                dispatch(newFeedLoaded(posts.results));
                return posts;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadGroupPosts(criteria) {
    return dispatch => {
        return postCommentsApi.getGroupPosts(criteria)
            .then(posts => {
                posts.results.map(post => {
                    post.postedOn = moment(post.postedOn).subtract(offSet, 'm');
                })
                dispatch(groupPostsLoaded(posts.results));
                return posts;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadEventPosts(criteria) {
    return dispatch => {
        return postCommentsApi.getEventPosts(criteria)
            .then(posts => {
                posts.results.map(post => {
                    post.postedOn = moment(post.postedOn).subtract(offSet, 'm');
                })
                dispatch(eventPostsLoaded(posts.results));
                return posts;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function loadPost(postId) {
    return dispatch => {
        return postCommentsApi.getPost(postId)
            .then(post => {
                post.postedOn = moment(post.postedOn).subtract(offSet, 'm');
                dispatch(postLoaded(post));
                return post;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}


export function loadPostComments(postId) {
    return dispatch => {
        return postCommentsApi.getPostComments(postId)
            .then(comments => {
                comments.map(comment => {
                    comment.postedOn = moment(comment.postedOn).subtract(offSet, 'm');
                })
                dispatch(postCommentsLoaded(comments));
                return comments;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function addPost(post) {
    return dispatch => {
        return postCommentsApi.addPost(post)
            .then(postId => {
                post.id = postId;
                dispatch(postAdded(post));
                return postId;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function editPost(post) {
    return dispatch => {
        return postCommentsApi.editPost(post)
            .then((savedPost) => {
                dispatch(postEdited(post));
                return savedPost;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function deletePost(post) {
    return dispatch => {
        return postCommentsApi.deletePost(post)
            .then(() => {
                dispatch(postDeleted(post));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function addComment(comment) {
    return dispatch => {
        return postCommentsApi.addComment(comment)
            .then(commentId => {
                comment.id = commentId;
                dispatch(commentAdded(comment));
                return commentId;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function editComment(comment) {
    return dispatch => {
        return postCommentsApi.editComment(comment)
            .then((savedComment) => {
                dispatch(commentEdited(comment));
                return savedComment;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function deleteComment(comment) {
    return dispatch => {
        return postCommentsApi.deleteComment(comment)
            .then(() => {
                dispatch(commentDeleted(comment));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function deletePostImage(postId, fileName) {
    return dispatch => {
        return postCommentsApi.deletePostImage(postId, fileName)
            .then(() => {
                dispatch(postImageDeleted(postId, fileName));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function deleteCommentImage(commentId, fileName) {
    return dispatch => {
        return postCommentsApi.deleteCommentImage(commentId, fileName)
            .then(() => {
                dispatch(commentImageDeleted(commentId, fileName));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function uploadImages(images) {
    return dispatch => {
        return postCommentsApi.uploadImages(images)
            .then(() => {
                //dispatch(commentDeleted(comment));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function react(reaction) {
    return dispatch => {
        return postCommentsApi.react(reaction)
            .then(() => {
                dispatch(reactedToPost(reaction));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function unReact(reaction) {
    return dispatch => {
        return postCommentsApi.unReact(reaction)
            .then(() => {
                dispatch(unReactedToPost(reaction));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function changeReaction(reaction) {
    return dispatch => {
        return postCommentsApi.changeReaction(reaction)
            .then(() => {
                dispatch(changeReactionToPost(reaction));
                return;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/postCommentActions.js